import React from "react";


export default function Schedule() {


    return (<>

        <div style={{ "textAlign": "left", "width": "255px", "minWidth": "200px" }}>
            <p>You have scheduled Bookmanager software backups set to run on the following stations and times:</p>
            <div className="shim" /><div className="shim" />
            <div style={{ "display": "flex", "flexDirection": "column", "textAlign": "left", "padding": "10px", "border": "1px solid #ffffff44" }}>
                <div style={{ "borderBottom": '1px dashed #ffffff44', "display" : "flex" }} key={"header"}>
                    <div style={{ "flex": "2 1 0", "padding": "4px 8px" }}><strong>Task</strong></div>
                    <div style={{ "padding": "4px 8px", "width": "60px" }}><strong>Station</strong></div>
                    <div style={{ "padding": "4px 8px", "width": "60px" }}><strong>Time</strong></div>
                </div>
                <div className="shim" />
                {window?.settings?.backup_schedules.map((row, i) => (
                    <div key={i} style={{"display" : "flex"}}>
                        <div style={{ "flex": "2 1 0", "padding": "4px 8px" }}>{row.task}</div>
                        <div style={{ "padding": "4px 8px", "width": "60px" }}>{row.station}</div>
                        <div style={{ "padding": "4px 8px", "width": "60px" }}>{row.time}</div>
                    </div>
                ))}

            </div>
            <div className="shim" /><div className="shim" />
            <p>
                While we ingest new backups, this app will be put into "Maintenance Mode". <strong>This down-time can last up to 45 minutes, at which time you will be unable to access any functions of BMO.</strong>
                <br /><br />
                If you need to use BMO during this time, we highly recommend that you go to the <strong>Scheduler</strong> on any station, type <kbd className="light">W</kbd> for workstation to isolate the station running your backup routine(s), and toggle the upcoming <strong>Backup Bookmanager</strong> routine(s) to <strong>Off</strong>. Make sure to <strong>set yourself a reminder to turn the routine(s) back on</strong> after you are done with BMO.
            </p>
        </div>

    </>)

}